import React from "react";
import styled from "styled-components";

import LogoImg from "../images/nickelodeon.png";

/* ========= ESTILOS ========= */

// Barra superior tipo landing principal
const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;

  background: #f3f4f6;
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border-bottom: 1px solid rgba(148, 163, 184, 0.25);
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.08);
`;

// Contenedor interno: MISMA IDEA que la landing (max-width centrado + padding)
const NavInner = styled.div`
  max-width: 1180px;        /* ancho similar al de la landing */
  margin: 0 auto;           /* centra el bloque */
  padding: 8px 32px;        /* espacio entre bordes y logo/botones */
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;

  @media (max-width: 1024px) {
    padding: 8px 24px;
  }

  @media (max-width: 768px) {
    padding: 8px 16px;
  }
`;

/* ========== BRAND (logo + textos) ========== */

const BrandGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;

const Logo = styled.img`
  height: 40px;   /* muy similar al header de la landing */
  width: auto;
  max-width: 100%;
`;

const BrandText = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.1;
  white-space: nowrap;

  @media (max-width: 480px) {
    display: none; /* en móviles muy pequeños solo mostramos el logo */
  }
`;

const BrandTitle = styled.span`
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: #4b5563;
`;

const BrandSubtitle = styled.span`
  font-size: 0.68rem;
  color: rgba(55, 65, 81, 0.85);
`;

/* ========== LADO DERECHO (idioma + soporte) ========== */

const RightGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
`;

// Selector de idioma tipo pill (EN / ES)
const LanguageContainer = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 3px;
  border-radius: 999px;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.12);
`;

const Language = styled.button`
  border: none;
  outline: none;
  cursor: pointer;

  padding: 6px 14px;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;

  background-color: ${(props) =>
    props.active ? "#8BC34A" : "transparent"};
  color: ${(props) => (props.active ? "#ffffff" : "#4b5563")};

  transition: background-color 0.2s ease, color 0.2s ease;

  &:hover {
    background-color: ${(props) =>
      props.active ? "#8BC34A" : "rgba(148, 163, 184, 0.18)"};
  }
`;

// Botón SOPORTE, visualmente similar a las pills del menú de la landing
const NavLink = styled.a`
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;

  padding: 8px 20px;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.6);
  background: #ffffff;
  color: #4b5563;

  text-decoration: none;
  transition: background-color 0.2s ease, color 0.2s ease,
    box-shadow 0.2s ease, border-color 0.2s ease;

  &:hover {
    background: #e5f3ff;
    color: #111827;
    border-color: rgba(59, 130, 246, 0.6);
    box-shadow: 0 3px 10px rgba(15, 23, 42, 0.15);
  }
`;

/* ========= COMPONENTE ========= */

function Header(props) {
  const { language, setLanguage, logo } = props;

  return (
    <HeaderContainer>
      <NavInner>
        {/* Izquierda: Logo + textos, con separación del borde igual que landing */}
        <BrandGroup>
          <Logo src={logo || LogoImg} alt="GIMAV Picture" />
          <BrandText>
            <BrandTitle>GIMAV PICTURE</BrandTitle>
            <BrandSubtitle>Foto turística inteligente</BrandSubtitle>
          </BrandText>
        </BrandGroup>

        {/* Derecha: Selector de idioma + SOPORTE */}
        <RightGroup>
          <LanguageContainer>
            <Language
              type="button"
              active={language === "en"}
              onClick={() => setLanguage("en")}
            >
              EN
            </Language>
            <Language
              type="button"
              active={language === "es"}
              onClick={() => setLanguage("es")}
            >
              ES
            </Language>
          </LanguageContainer>

          <NavLink href="/soporte.html" target="_blank" rel="noreferrer">
            SOPORTE
          </NavLink>
        </RightGroup>
      </NavInner>
    </HeaderContainer>
  );
}

export default Header;
